import React from "react";
import { HeaderProps, UseHeaderProps } from "./type";
import { useHeader } from "./useHeader";
import HeaderView from "./HeaderView";

function Header(props: HeaderProps) {
  const hook: UseHeaderProps = useHeader(props);

  return <HeaderView props={props} hook={hook} />;
}
export default React.memo(Header);
